import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Grid, IconButton, Paper, Table, TableContainer, TableRow } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import { useTranslation } from "react-i18next";
import { StyledTableCell, StyledTableHead } from "../../components/table/BaseTable/BaseTable";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { useDeleteSeller, useGetSellers } from "../../services/usersApi";
import { CreateEmailFooterButton } from "./EmailFooter/CreateEmailFooterButton";
import { ManageEmailFootersButton } from "./EmailFooter/ManageEmailFootersButton";
import { SellerCreateDialog } from "./SellerCreateDialog";

export const SalesSellersPage = (props) => {
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();
    const { data: sellers } = useGetSellers();
    const { mutate: deleteSeller } = useDeleteSeller();

    const handleDelete = (id) => {
        deleteSeller({ id });
        console.debug("Delete seller with id:", id);
    };

    const handleAdd = () => {
        openDialog({
            Component: SellerCreateDialog,
            componentProps: {
                existingSellersUserIds: sellers?.map((s) => s.user_id) || [],
            },
        });
    };

    return (
        // @ts-ignore
        <DefaultPageWrapper tagTitle={t("headers.sellers")}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Button onClick={() => handleAdd()}>{t("sellers.SalesSellersPage.add")}</Button>
                </Grid>

                <Grid container item xs={12} spacing={2} justifyContent="center">
                    <Grid item xs={8}>
                        <TableContainer component={Paper}>
                            <Table>
                                <StyledTableHead>
                                    <TableRow>
                                        <StyledTableCell>
                                            {t("sellers.SalesSellersPage.salesman")}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t("sellers.SalesSellersPage.scope")}
                                        </StyledTableCell>
                                        {/* <StyledTableCell /> */}
                                        <StyledTableCell>
                                            {t("sellers.SalesSellersPage.emailFooter")}
                                        </StyledTableCell>
                                    </TableRow>
                                </StyledTableHead>
                                <TableBody>
                                    {sellers?.map((seller) => (
                                        <TableRow key={seller.id}>
                                            <StyledTableCell>{seller.full_name}</StyledTableCell>
                                            <StyledTableCell>{seller.scope}</StyledTableCell>
                                            {/* <StyledTableCell>
                                                <IconButton onClick={() => handleDelete(seller.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </StyledTableCell> */}
                                            <StyledTableCell>
                                                {seller.email_footers.length > 0 ? (
                                                    <ManageEmailFootersButton
                                                        sellerId={seller.id}
                                                    />
                                                ) : (
                                                    <CreateEmailFooterButton sellerId={seller.id} />
                                                )}
                                            </StyledTableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Grid>
        </DefaultPageWrapper>
    );
};
